import React from "react";
import { Drawer } from "./Drawer";
import { useSteps } from "../../utils/hooks/useSteps";
import MuiStepper from "@mui/material/Stepper";
import MuiStep from "@mui/material/Step";
import MuiStepLabel from "@mui/material/StepLabel";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import styled from "@mui/material/styles/styled";

const NavigationButton = styled(Button)(({ theme }) => ({
  width: "80px",
  height: "auto",
  transition: "all 0.5s",
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.primary.light,
  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
    transform: "scale(1.05)",
  },
}));

export const Stepper = ({ stepContent, ahuType, coils, onNext, onPrevious }) => {
  const { t } = useTranslation();
  const {
    steps,
    activeStep,
    activeStepIndex,
    nextStep,
    previousStep,
    completeStep,
  } = useSteps(ahuType, { coils });

  const handleNext = (e) => {
    onNext?.(e, activeStep.id)
      .then(() => {
        completeStep(activeStep.id);
        nextStep();
      })
      .catch((error) => {
        return error;
      });
  };
  const handlePrevious = () => {
    onPrevious?.(activeStep.id);
    previousStep();
  };

  return (
    <Box sx={{ display: "flex", minHeight: "70vh" }}>
      <Drawer>
        <MuiStepper activeStep={activeStepIndex} orientation="vertical">
          {steps.map((step) => (
            <MuiStep key={step.id}>
              <MuiStepLabel icon={step.icon}>{step.label}</MuiStepLabel>
            </MuiStep>
          ))}
        </MuiStepper>
      </Drawer>
      <Box flexDirection="column" width="100%">
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          width="100%"
          px="24px"
          mt={3}
          mb={4}
        >
          <NavigationButton
            disabled={activeStepIndex === 0}
            onClick={handlePrevious}
          >
            {t("mainform.back")}
          </NavigationButton>
          <NavigationButton
            onClick={handleNext}
            disabled={activeStepIndex === steps.length}
          >
            {t("mainform.next")}
          </NavigationButton>
        </Box>
        <Container>
          {stepContent.find((component) => component.key === activeStep?.id)}
        </Container>
      </Box>
    </Box>
  );
};
